<template>
    <div class="card mb-xl-3 mb-1">
        <div class="card-body p-1">
            <a href="#" class="card-header-action btn btn-lg btn-block btn-success p-xl-4 p-1 py-3 readyButton" @click.prevent="toggleReady()">
                <i class="fas fa-play"></i>
                {{slots > 1 ? __(multi) : __(single)}}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ready: false,
                single: "lobby.click_here_to_start_the_game",
                multi: "lobby.click_here_when_ready",
                slot: 0,
                slots: 2,
            }
        },
        mounted() {
            this.$root.$on('MatchRequestLobbySendSlot', (slot) => {
                this.slot = slot;
            });

            this.$root.$on('MatchRequestLobbySlotCount', (slots) => {
                this.slots = slots;
            });
        },
        methods: {
            toggleReady() {
                this.ready = !this.ready;
                this.$root.$emit('LobbyStartButtonToggleReady', {state: this.ready, slot: this.slot});
            }
        }
    }
</script>

<style scoped>
    .readyButton {
        font-size: 1.3rem;
    }
</style>
